"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSessoAggiungiContatto = exports.setDataDiNascitaAggiungiContatto = exports.setCognomeAggiungiContatto = exports.setNomeAggiungiContatto = exports.rimuoviAltoAdigePassAggiungiContatto = exports.aggiungiAltoAdigePassAggiungiContatto = exports.setAltoAdigePassDispensaAggiungiContatto = exports.setAltoAdigePassAliasAggiungiContatto = exports.setAltoAdigePassAggiungiContatto = exports.rimuoviTargaAggiungiContatto = exports.aggiungiTargaAggiungiContatto = exports.setTargaDispensaAggiungiContatto = exports.setTargaAliasAggiungiContatto = exports.setTargaAggiungiContatto = exports.rimuoviTelefonoAggiungiContatto = exports.aggiungiTelefonoAggiungiContatto = exports.setTelefonoDispensaAggiungiContatto = exports.setTelefonoAliasAggiungiContatto = exports.setTelefonoAggiungiContatto = exports.rimuoviIbanAggiungiContatto = exports.aggiungiIbanAggiungiContatto = exports.setIbanDispensaAggiungiContatto = exports.setIbanAliasAggiungiContatto = exports.setIbanAggiungiContatto = exports.rimuoviEmailAggiungiContatto = exports.aggiungiEmailAggiungiContatto = exports.setEmailAggiungiContatto = exports.setDispensaCredenzialeAggiungiContatto = exports.setAliasAggiungiContatto = exports.setAccordionDatiF24RubricaOpened = exports.setAccordionDatiAltoAdigePassRubricaOpened = exports.setAccordionDatiBolloRubricaOpened = exports.setAccordionDatiRicaricaRubricaOpened = exports.setAccordionDatiBonificoRubricaOpened = exports.setAccordionDatiPersonaliRubricaOpened = exports.setAggiungiContattoSetStep = exports.autorizzaAggiungiContattoRubrica = exports.getInfoAutenticazioneAggiungiContattoRubrica = exports.controlloContattoRubrica = exports.resetRubricaContatti = exports.eliminaContattoRubrica = exports.getParametriRubrica = exports.resetRubricaContattoSelezionato = exports.setRubricaSetContattoSelezionato = exports.resetFiltroContatti = exports.setRubricaSetAccordionFiltriOpened = exports.setRubricaSetContenuto = exports.setRubricaSetTipoBeneficiario = exports.getContattiRubricaLight = exports.getContattiRubrica = void 0;
exports.resetRiepilogoRubrica = exports.resetFormRubrica = exports.setModificaContattoRubrica = exports.setFormSubmittedAggiungiContatto = exports.setPartitaIvaAggiungiContatto = exports.setDispensaCodiceFiscaleAggiungiContatto = exports.setCodiceFiscaleAggiungiContatto = exports.setProvinciaAggiungiContatto = exports.setComuneAggiungiContatto = exports.setCapAggiungiContatto = exports.setIndirizzoAggiungiContatto = exports.setProvinciaNascitaAggiungiContatto = exports.setLuogoNascitaAggiungiContatto = void 0;
const api_rest_1 = require("@sparkasse/api-rest");
const __1 = require("..");
const general_1 = require("../general");
const general_configuration_1 = require("../general/general.configuration");
const helpers_1 = require("../helpers");
const rubrica_selectors_1 = require("./rubrica.selectors");
/* get contatti rubrica - START */
function getContattiRubricaStart() {
    return {
        type: __1.EReduxActionTypes.RUBRICA_GET_CONTATTI_START
    };
}
function getContattiRubricaSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_GET_CONTATTI_SUCCESS,
        payload
    };
}
function generalError(value, showGenericModalError) {
    return async (dispatch) => {
        dispatch((0, general_1.setError)(value, showGenericModalError));
    };
}
const getContattiRubrica = (contattiInputRequest) => async (dispatch, getState, extraArguments) => {
    dispatch((0, general_1.setLoader)(true));
    dispatch(getContattiRubricaStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/contatti.json')).then(parametri => {
            dispatch(getContattiRubricaSuccess((0, api_rest_1.ContattiDtoFromJSON)(parametri)));
            dispatch((0, general_1.setLoader)(false));
        });
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            const filtroListaContattiDto = contattiInputRequest || {
                parolaChiave: contattiInputRequest || getState().rubricaContatti.filter.contenuto
            };
            const request = {
                filtroListaContattiDto
            };
            new api_rest_1.ContattiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).elencoContatti(request).then((response) => {
                dispatch(getContattiRubricaSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_1.setLoader)(false));
            });
        });
    }
};
exports.getContattiRubrica = getContattiRubrica;
/* get contatti rubrica - FINE */
/* get contatti rubrica light - START */
function getContattiRubricaLightStart() {
    return {
        type: __1.EReduxActionTypes.RUBRICA_LIGHT_GET_CONTATTI_START
    };
}
function getContattiRubricaLightSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_LIGHT_GET_CONTATTI_SUCCESS,
        payload
    };
}
const getContattiRubricaLight = (tipo) => async (dispatch, getState, extraArguments) => {
    dispatch((0, general_1.setLoader)(true));
    dispatch(getContattiRubricaLightStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/contatti.json')).then(parametri => {
            dispatch(getContattiRubricaLightSuccess((0, api_rest_1.ContattiDtoFromJSON)(parametri)));
            dispatch((0, general_1.setLoader)(false));
        });
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            const request = {
                filtroListaContattiDto: {
                    tipo
                }
            };
            new api_rest_1.ContattiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).getContattiRubricaLight(request).then((response) => {
                dispatch(getContattiRubricaLightSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_1.setLoader)(false));
            });
        });
    }
};
exports.getContattiRubricaLight = getContattiRubricaLight;
/* get contatti rubrica light - FINE */
/* set filtri rubrica - INIZIO */
function setRubricaSetTipoBeneficiario(txt) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_TIPO_BENEFICIARIO,
        payload: txt
    };
}
exports.setRubricaSetTipoBeneficiario = setRubricaSetTipoBeneficiario;
function setRubricaSetContenuto(txt) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_CONTENUTO,
        payload: txt
    };
}
exports.setRubricaSetContenuto = setRubricaSetContenuto;
function setRubricaSetAccordionFiltriOpened(b) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_ACCORDION_FILTRI_OPENED,
        payload: b
    };
}
exports.setRubricaSetAccordionFiltriOpened = setRubricaSetAccordionFiltriOpened;
function resetFiltroContatti() {
    return {
        type: __1.EReduxActionTypes.RUBRICA_RESET_FILTRO
    };
}
exports.resetFiltroContatti = resetFiltroContatti;
/* set filtri rubrica - FINE */
/* set contatto selezionato - INIZIO */
function setRubricaSetContattoSelezionato(contatto) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_CONTATTO_SELEZIONATO,
        payload: contatto
    };
}
exports.setRubricaSetContattoSelezionato = setRubricaSetContattoSelezionato;
function resetRubricaContattoSelezionato() {
    return {
        type: __1.EReduxActionTypes.RUBRICA_RESET_CONTATTO_SELEZIONATO
    };
}
exports.resetRubricaContattoSelezionato = resetRubricaContattoSelezionato;
/* set contatto selezionato - FINE */
/* get parametri rubrica - START */
function getParametriRubricaStart() {
    return {
        type: __1.EReduxActionTypes.RUBRICA_GET_PARAMETRI_START
    };
}
function getParametriRubricaSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_GET_PARAMETRI_SUCCESS,
        payload
    };
}
const getParametriRubrica = () => async (dispatch, getState, extraArguments) => {
    dispatch((0, general_1.setLoader)(true));
    dispatch(getParametriRubricaStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/parametri_contatti.json')).then(parametri => {
            dispatch(getParametriRubricaSuccess((0, api_rest_1.ParametriContattiDtoFromJSON)(parametri)));
            dispatch((0, general_1.setLoader)(false));
        });
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.ContattiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).parametriContatti().then((response) => {
                dispatch(getParametriRubricaSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_1.setLoader)(false));
            });
        });
    }
};
exports.getParametriRubrica = getParametriRubrica;
/* get parametri rubrica - FINE */
/* elimina contatto rubrica - START */
function eliminaContattoRubricaStart() {
    return {
        type: __1.EReduxActionTypes.RUBRICA_ELIMINA_CONTATTO_START
    };
}
function eliminaContattoRubricaSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_ELIMINA_CONTATTO_SUCCESS,
        payload
    };
}
const eliminaContattoRubrica = (id) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_1.setLoader)(true));
    dispatch(eliminaContattoRubricaStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/operazionidefault.json')).then(() => {
            dispatch(eliminaContattoRubricaSuccess(id));
        });
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            const request = {
                removeContattoReqInDto: {
                    // credenziale?: CredenzialeDispositivaDto;
                    // funzione?: string;
                    idContatto: id
                }
            };
            new api_rest_1.ContattiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).operazioneAutenticataEliminaContatto(request).then(() => {
                // dispatch(eliminaContattoRubricaSuccess(id));
                dispatch((0, exports.getContattiRubrica)());
                dispatch((0, general_1.addSnackbar)('rubrica.beneficiarioEliminatoConSuccesso'));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_1.setLoader)(false));
            });
        });
    }
};
exports.eliminaContattoRubrica = eliminaContattoRubrica;
/* elimina contatto rubrica - FINE */
function resetRubricaContatti() {
    return {
        type: __1.EReduxActionTypes.RUBRICA_RESET_CONTATTI
    };
}
exports.resetRubricaContatti = resetRubricaContatti;
// salva contatto in rubrica
// - controlloContattoRubrica(contatto: ContattoDto) - checkContatto
// - getInfoAutenticazioneAggiungiContattoRubrica(idContatto: string) - authenticationInformationContatto
// - autorizzaAggiungiContattoRubrica(idContatto: string, credenziale: CredenzialeDispositivaDto) - authorizeContatto
/* controllo contatto - START */
function controlloContattoRubricaStart() {
    return {
        type: __1.EReduxActionTypes.RUBRICA_CONTROLLO_CONTATTO_START
    };
}
function controlloContattoRubricaSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_CONTROLLO_CONTATTO_SUCCESS,
        payload
    };
}
const controlloContattoRubrica = () => async (dispatch, getState, extraArguments) => {
    const stateRubrica = getState().rubricaContatti;
    dispatch(setFormSubmittedAggiungiContatto(true));
    if ((0, rubrica_selectors_1.formAggiungiContattoValid)(stateRubrica)) {
        dispatch((0, general_1.setLoader)(true));
        dispatch(controlloContattoRubricaStart());
        if (extraArguments.mock) {
            Promise.resolve().then(() => require('../../mock/controllo_contatto.json')).then(contatto => {
                dispatch(controlloContattoRubricaSuccess((0, api_rest_1.ContattoDtoFromJSON)(contatto)));
                dispatch((0, general_1.setLoader)(false));
            });
        }
        else {
            extraArguments.getItem('jwt').then((jwt) => {
                if (stateRubrica.formAggiungiContatto.id) {
                    const request = {
                        contattoDto: (0, rubrica_selectors_1.buildContatto)(stateRubrica)
                    };
                    new api_rest_1.ContattiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).modificaContatto(request).then((response) => {
                        dispatch(controlloContattoRubricaSuccess(response));
                    }).catch(async (error) => {
                        dispatch(generalError(await (0, helpers_1.formatError)(error)));
                    }).finally(() => {
                        dispatch((0, general_1.setLoader)(false));
                    });
                }
                else {
                    const request = {
                        contattoDto: (0, rubrica_selectors_1.buildContatto)(stateRubrica)
                    };
                    new api_rest_1.ContattiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).addContatto(request).then((response) => {
                        dispatch(controlloContattoRubricaSuccess(response));
                    }).catch(async (error) => {
                        dispatch(generalError(await (0, helpers_1.formatError)(error)));
                    }).finally(() => {
                        dispatch((0, general_1.setLoader)(false));
                    });
                }
            });
        }
    }
};
exports.controlloContattoRubrica = controlloContattoRubrica;
/* controllo contatto - FINE */
/* get info autenticazione aggiungi contatto - START */
function getInfoAutenticazioneAggiungiContattoRubricaStart() {
    return {
        type: __1.EReduxActionTypes.RUBRICA_GET_INFO_DISPOSITIVA_AGGIUNGI_CONTATTO_START
    };
}
function getInfoAutenticazioneAggiungiContattoRubricaSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_GET_INFO_DISPOSITIVA_AGGIUNGI_CONTATTO_SUCCESS,
        payload
    };
}
const getInfoAutenticazioneAggiungiContattoRubrica = (idContatto, eseguiInit, chiamataUscente, offline) => async (dispatch, getState, extraArguments) => {
    dispatch((0, general_1.setLoader)(true));
    dispatch(getInfoAutenticazioneAggiungiContattoRubricaStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/operazionidefault.json')).then(() => {
            dispatch(getInfoAutenticazioneAggiungiContattoRubricaSuccess((0, api_rest_1.InformazioniAutenticazioneDispositivaDtoFromJSON)({})));
            dispatch((0, general_1.setLoader)(false));
        });
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            const stateRubrica = getState().rubricaContatti;
            if (stateRubrica.formAggiungiContatto.id) {
                const request = {
                    codiceFunzione: stateRubrica.riepilogoAggiungiContatto.codiceFunzione,
                    idContatto: stateRubrica.riepilogoAggiungiContatto.idVirtuale,
                    chiamataUscente,
                    eseguiInit,
                    offline: !!offline
                };
                new api_rest_1.ContattiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).authenticationInformationModificaContatto(request).then((response) => {
                    dispatch(getInfoAutenticazioneAggiungiContattoRubricaSuccess(response));
                }).catch(async (error) => {
                    dispatch(generalError(await (0, helpers_1.formatError)(error)));
                }).finally(() => {
                    dispatch((0, general_1.setLoader)(false));
                });
            }
            else {
                const request = {
                    codiceFunzione: stateRubrica.riepilogoAggiungiContatto.codiceFunzione,
                    idContatto: String(stateRubrica.riepilogoAggiungiContatto.id),
                    chiamataUscente,
                    eseguiInit,
                    offline: !!offline
                };
                new api_rest_1.ContattiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).authenticationInformationContatto(request).then((response) => {
                    dispatch(getInfoAutenticazioneAggiungiContattoRubricaSuccess(response));
                }).catch(async (error) => {
                    dispatch(generalError(await (0, helpers_1.formatError)(error)));
                }).finally(() => {
                    dispatch((0, general_1.setLoader)(false));
                });
            }
        });
    }
};
exports.getInfoAutenticazioneAggiungiContattoRubrica = getInfoAutenticazioneAggiungiContattoRubrica;
/* get info autenticazione aggiungi contatto - FINE */
/* autorizza aggiungi contatto - START */
function autorizzaAggiungiContattoRubricaStart() {
    return {
        type: __1.EReduxActionTypes.RUBRICA_AUTORIZZA_AGGIUNGI_CONTATTO_START
    };
}
function autorizzaAggiungiContattoRubricaSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_AUTORIZZA_AGGIUNGI_CONTATTO_SUCCESS,
        payload
    };
}
const autorizzaAggiungiContattoRubrica = (idContatto, credenziale) => async (dispatch, getState, extraArguments) => {
    dispatch((0, general_1.setLoader)(true));
    dispatch(autorizzaAggiungiContattoRubricaStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/operazionidefault.json')).then(() => {
            dispatch(autorizzaAggiungiContattoRubricaSuccess((0, api_rest_1.EsitoAutorizzazioneDisposizioneContattoDtoFromJSON)({})));
            dispatch((0, general_1.setLoader)(false));
        });
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            const stateRubrica = getState().rubricaContatti;
            if (stateRubrica.formAggiungiContatto.id) {
                const request = {
                    codiceFunzione: stateRubrica.riepilogoAggiungiContatto.codiceFunzione,
                    idContatto: stateRubrica.riepilogoAggiungiContatto.idVirtuale,
                    credenzialeDispositivaDto: credenziale
                };
                new api_rest_1.ContattiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).authorizeModificaContatto(request).then((response) => {
                    dispatch(autorizzaAggiungiContattoRubricaSuccess(response));
                }).catch(async (error) => {
                    dispatch(generalError(await (0, helpers_1.formatError)(error), false));
                }).finally(() => {
                    dispatch((0, general_1.setLoader)(false));
                });
            }
            else {
                const request = {
                    codiceFunzione: stateRubrica.riepilogoAggiungiContatto.codiceFunzione,
                    idContatto: String(stateRubrica.riepilogoAggiungiContatto.id),
                    credenzialeDispositivaDto: credenziale
                };
                new api_rest_1.ContattiControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).authorizeContatto(request).then((response) => {
                    dispatch(autorizzaAggiungiContattoRubricaSuccess(response));
                }).catch(async (error) => {
                    dispatch(generalError(await (0, helpers_1.formatError)(error), false));
                }).finally(() => {
                    dispatch((0, general_1.setLoader)(false));
                });
            }
        });
    }
};
exports.autorizzaAggiungiContattoRubrica = autorizzaAggiungiContattoRubrica;
/* autorizza aggiungi contatto - FINE */
function setAggiungiContattoSetStepAction(step) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_AGGIUNGI_CONTATTO_SET_STEP,
        payload: step
    };
}
const setAggiungiContattoSetStep = (step) => async (dispatch, _, extraArguments) => {
    dispatch(setAggiungiContattoSetStepAction(step));
    if (extraArguments.platform == 'mobile') {
        dispatch((0, general_1.setBottomTabBarVisible)(step != 1));
    }
};
exports.setAggiungiContattoSetStep = setAggiungiContattoSetStep;
function setAccordionDatiPersonaliRubricaOpened(opened) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_ACCORDION_DATI_PERSONALI_OPENED,
        payload: opened
    };
}
exports.setAccordionDatiPersonaliRubricaOpened = setAccordionDatiPersonaliRubricaOpened;
function setAccordionDatiBonificoRubricaOpened(opened) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_ACCORDION_DATI_BONIFICO_OPENED,
        payload: opened
    };
}
exports.setAccordionDatiBonificoRubricaOpened = setAccordionDatiBonificoRubricaOpened;
function setAccordionDatiRicaricaRubricaOpened(opened) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_ACCORDION_DATI_RICARICA_OPENED,
        payload: opened
    };
}
exports.setAccordionDatiRicaricaRubricaOpened = setAccordionDatiRicaricaRubricaOpened;
function setAccordionDatiBolloRubricaOpened(opened) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_ACCORDION_DATI_BOLLO_OPENED,
        payload: opened
    };
}
exports.setAccordionDatiBolloRubricaOpened = setAccordionDatiBolloRubricaOpened;
function setAccordionDatiAltoAdigePassRubricaOpened(opened) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_ACCORDION_DATI_ALTOADIGEPASS_OPENED,
        payload: opened
    };
}
exports.setAccordionDatiAltoAdigePassRubricaOpened = setAccordionDatiAltoAdigePassRubricaOpened;
function setAccordionDatiF24RubricaOpened(opened) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_ACCORDION_DATI_F24_OPENED,
        payload: opened
    };
}
exports.setAccordionDatiF24RubricaOpened = setAccordionDatiF24RubricaOpened;
function setAliasAggiungiContatto(alias) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_ALIAS_AGGIUNGI_CONTATTO,
        payload: alias
    };
}
exports.setAliasAggiungiContatto = setAliasAggiungiContatto;
function setDispensaCredenzialeAggiungiContatto(dispensa) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_DISPENSA_CREDENZIALE_AGGIUNGI_CONTATTO,
        payload: dispensa
    };
}
exports.setDispensaCredenzialeAggiungiContatto = setDispensaCredenzialeAggiungiContatto;
function setEmailAggiungiContatto(value, index) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_EMAIL_AGGIUNGI_CONTATTO,
        payload: { value, index }
    };
}
exports.setEmailAggiungiContatto = setEmailAggiungiContatto;
function aggiungiEmailAggiungiContatto() {
    return {
        type: __1.EReduxActionTypes.RUBRICA_AGGIUNGI_EMAIL_AGGIUNGI_CONTATTO
    };
}
exports.aggiungiEmailAggiungiContatto = aggiungiEmailAggiungiContatto;
function rimuoviEmailAggiungiContatto(index) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_RIMUOVI_EMAIL_AGGIUNGI_CONTATTO,
        payload: index
    };
}
exports.rimuoviEmailAggiungiContatto = rimuoviEmailAggiungiContatto;
function setIbanAggiungiContatto(value, index) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_IBAN_AGGIUNGI_CONTATTO,
        payload: { value, index }
    };
}
exports.setIbanAggiungiContatto = setIbanAggiungiContatto;
function setIbanAliasAggiungiContatto(value, index) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_IBAN_ALIAS_AGGIUNGI_CONTATTO,
        payload: { value, index }
    };
}
exports.setIbanAliasAggiungiContatto = setIbanAliasAggiungiContatto;
function setIbanDispensaAggiungiContatto(value, index) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_IBAN_DISPENSA_AGGIUNGI_CONTATTO,
        payload: { value, index }
    };
}
exports.setIbanDispensaAggiungiContatto = setIbanDispensaAggiungiContatto;
function aggiungiIbanAggiungiContatto() {
    return {
        type: __1.EReduxActionTypes.RUBRICA_AGGIUNGI_IBAN_AGGIUNGI_CONTATTO
    };
}
exports.aggiungiIbanAggiungiContatto = aggiungiIbanAggiungiContatto;
function rimuoviIbanAggiungiContatto(index) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_RIMUOVI_IBAN_AGGIUNGI_CONTATTO,
        payload: index
    };
}
exports.rimuoviIbanAggiungiContatto = rimuoviIbanAggiungiContatto;
function setTelefonoAggiungiContatto(value, index) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_TELEFONO_AGGIUNGI_CONTATTO,
        payload: { value, index }
    };
}
exports.setTelefonoAggiungiContatto = setTelefonoAggiungiContatto;
function setTelefonoAliasAggiungiContatto(value, index) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_TELEFONO_ALIAS_AGGIUNGI_CONTATTO,
        payload: { value, index }
    };
}
exports.setTelefonoAliasAggiungiContatto = setTelefonoAliasAggiungiContatto;
function setTelefonoDispensaAggiungiContatto(value, index) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_TELEFONO_DISPENSA_AGGIUNGI_CONTATTO,
        payload: { value, index }
    };
}
exports.setTelefonoDispensaAggiungiContatto = setTelefonoDispensaAggiungiContatto;
function aggiungiTelefonoAggiungiContatto() {
    return {
        type: __1.EReduxActionTypes.RUBRICA_AGGIUNGI_TELEFONO_AGGIUNGI_CONTATTO
    };
}
exports.aggiungiTelefonoAggiungiContatto = aggiungiTelefonoAggiungiContatto;
function rimuoviTelefonoAggiungiContatto(index) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_RIMUOVI_TELEFONO_AGGIUNGI_CONTATTO,
        payload: index
    };
}
exports.rimuoviTelefonoAggiungiContatto = rimuoviTelefonoAggiungiContatto;
function setTargaAggiungiContatto(value, index) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_TARGA_AGGIUNGI_CONTATTO,
        payload: { value, index }
    };
}
exports.setTargaAggiungiContatto = setTargaAggiungiContatto;
function setTargaAliasAggiungiContatto(value, index) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_TARGA_ALIAS_AGGIUNGI_CONTATTO,
        payload: { value, index }
    };
}
exports.setTargaAliasAggiungiContatto = setTargaAliasAggiungiContatto;
function setTargaDispensaAggiungiContatto(value, index) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_TARGA_DISPENSA_AGGIUNGI_CONTATTO,
        payload: { value, index }
    };
}
exports.setTargaDispensaAggiungiContatto = setTargaDispensaAggiungiContatto;
function aggiungiTargaAggiungiContatto() {
    return {
        type: __1.EReduxActionTypes.RUBRICA_AGGIUNGI_TARGA_AGGIUNGI_CONTATTO
    };
}
exports.aggiungiTargaAggiungiContatto = aggiungiTargaAggiungiContatto;
function rimuoviTargaAggiungiContatto(index) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_RIMUOVI_TARGA_AGGIUNGI_CONTATTO,
        payload: index
    };
}
exports.rimuoviTargaAggiungiContatto = rimuoviTargaAggiungiContatto;
function setAltoAdigePassAggiungiContatto(value, index) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_ALTOADIGEPASS_AGGIUNGI_CONTATTO,
        payload: { value, index }
    };
}
exports.setAltoAdigePassAggiungiContatto = setAltoAdigePassAggiungiContatto;
function setAltoAdigePassAliasAggiungiContatto(value, index) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_ALTOADIGEPASS_ALIAS_AGGIUNGI_CONTATTO,
        payload: { value, index }
    };
}
exports.setAltoAdigePassAliasAggiungiContatto = setAltoAdigePassAliasAggiungiContatto;
function setAltoAdigePassDispensaAggiungiContatto(value, index) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_ALTOADIGEPASS_DISPENSA_AGGIUNGI_CONTATTO,
        payload: { value, index }
    };
}
exports.setAltoAdigePassDispensaAggiungiContatto = setAltoAdigePassDispensaAggiungiContatto;
function aggiungiAltoAdigePassAggiungiContatto() {
    return {
        type: __1.EReduxActionTypes.RUBRICA_AGGIUNGI_ALTOADIGEPASS_AGGIUNGI_CONTATTO
    };
}
exports.aggiungiAltoAdigePassAggiungiContatto = aggiungiAltoAdigePassAggiungiContatto;
function rimuoviAltoAdigePassAggiungiContatto(index) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_RIMUOVI_ALTOADIGEPASS_AGGIUNGI_CONTATTO,
        payload: index
    };
}
exports.rimuoviAltoAdigePassAggiungiContatto = rimuoviAltoAdigePassAggiungiContatto;
function setNomeAggiungiContatto(s) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_NOME_AGGIUNGI_CONTATTO,
        payload: s
    };
}
exports.setNomeAggiungiContatto = setNomeAggiungiContatto;
function setCognomeAggiungiContatto(s) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_COGNOME_AGGIUNGI_CONTATTO,
        payload: s
    };
}
exports.setCognomeAggiungiContatto = setCognomeAggiungiContatto;
function setDataDiNascitaAggiungiContatto(s) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_DATADINASCITA_AGGIUNGI_CONTATTO,
        payload: s
    };
}
exports.setDataDiNascitaAggiungiContatto = setDataDiNascitaAggiungiContatto;
function setSessoAggiungiContatto(s) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_SESSO_AGGIUNGI_CONTATTO,
        payload: s
    };
}
exports.setSessoAggiungiContatto = setSessoAggiungiContatto;
function setLuogoNascitaAggiungiContatto(s) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_LUOGONASCITA_AGGIUNGI_CONTATTO,
        payload: s
    };
}
exports.setLuogoNascitaAggiungiContatto = setLuogoNascitaAggiungiContatto;
function setProvinciaNascitaAggiungiContatto(s) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_PROVINCIANASCITA_AGGIUNGI_CONTATTO,
        payload: s
    };
}
exports.setProvinciaNascitaAggiungiContatto = setProvinciaNascitaAggiungiContatto;
function setIndirizzoAggiungiContatto(s) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_INDIRIZZO_AGGIUNGI_CONTATTO,
        payload: s
    };
}
exports.setIndirizzoAggiungiContatto = setIndirizzoAggiungiContatto;
function setCapAggiungiContatto(s) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_CAP_AGGIUNGI_CONTATTO,
        payload: s
    };
}
exports.setCapAggiungiContatto = setCapAggiungiContatto;
function setComuneAggiungiContatto(s) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_COMUNE_AGGIUNGI_CONTATTO,
        payload: s
    };
}
exports.setComuneAggiungiContatto = setComuneAggiungiContatto;
function setProvinciaAggiungiContatto(s) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_PROVINCIA_AGGIUNGI_CONTATTO,
        payload: s
    };
}
exports.setProvinciaAggiungiContatto = setProvinciaAggiungiContatto;
function setCodiceFiscaleAggiungiContatto(s) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_CODICEFISCALE_AGGIUNGI_CONTATTO,
        payload: s
    };
}
exports.setCodiceFiscaleAggiungiContatto = setCodiceFiscaleAggiungiContatto;
function setDispensaCodiceFiscaleAggiungiContatto(b) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_DISPENSA_CODICEFISCALE_AGGIUNGI_CONTATTO,
        payload: b
    };
}
exports.setDispensaCodiceFiscaleAggiungiContatto = setDispensaCodiceFiscaleAggiungiContatto;
function setPartitaIvaAggiungiContatto(s) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_PARTITAIVA_AGGIUNGI_CONTATTO,
        payload: s
    };
}
exports.setPartitaIvaAggiungiContatto = setPartitaIvaAggiungiContatto;
function setFormSubmittedAggiungiContatto(b) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_FORM_SUBMITTED_AGGIUNGI_CONTATTO,
        payload: b
    };
}
exports.setFormSubmittedAggiungiContatto = setFormSubmittedAggiungiContatto;
function setModificaContattoRubrica(contatto) {
    return {
        type: __1.EReduxActionTypes.RUBRICA_SET_MODIFICA_CONTATTO,
        payload: contatto
    };
}
exports.setModificaContattoRubrica = setModificaContattoRubrica;
function resetFormRubrica() {
    return {
        type: __1.EReduxActionTypes.RUBRICA_RESET_FORM
    };
}
exports.resetFormRubrica = resetFormRubrica;
function resetRiepilogoRubrica() {
    return {
        type: __1.EReduxActionTypes.RUBRICA_RESET_RIEPILOGO
    };
}
exports.resetRiepilogoRubrica = resetRiepilogoRubrica;
